import axios from "axios";
import React, {useEffect, useRef, useState} from "react";
import {customSelectMenuStyles, KoerberLanguageSelectorWrapper} from "./LanguageSelector.style";
import Select from 'react-select'

const LanguageSelector = ({isInEditor, scrollPosition, blackLetter, inFooter, pagePath, pageLanguage }) => {
    const [selectedLanguage, setSelectedLanguage] = useState(pageLanguage);
    const [languages, setLanguages] = useState([]);

    const [uniqueId] = React.useState(
        () => 'select_' + Math.random().toFixed(5).slice(2),
    );

    useEffect(() => {
        axios.get(`${pagePath}.languages-info.json`,
        )
            .then(response => {
                setLanguages(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const setUrl = (lang) => {
        const languageSelected = languages.filter(language => language.iso === lang)[0];
        if (!languageSelected) { //if the page on the cookie is not present in laguages array, do not redirect or a loop happens
            return;
        }
        if(languageSelected.iso !== pageLanguage){
            window.location.pathname = languageSelected.url;
        }
    }

    const handleLanguageChange = (event) => {
        setSelectedLanguage(event.value);
        handleLoadPage(event.value);
    };

    const handleLoadPage = (value = null) => {
        setUrl(value)
    }

    const selectRef = useRef(null);

    useEffect(() => {
        selectRef.current?.blur();
    }, [scrollPosition]);


    return (
        <>
            <KoerberLanguageSelectorWrapper className={`label-medium${inFooter ? ' in__footer' : ''}`} blackLetter={blackLetter}>
                <Select
                    id={uniqueId}
                    onChange={handleLanguageChange}
                    className="basic-single"
                    classNamePrefix="select"
                    defaultValue={selectedLanguage}
                    options={languages.map((language) => ({value:language.iso, label:language.language}))}
                    ref={selectRef}
                    value={[{label : selectedLanguage}]}
                    isSearchable={false}
                    onMenuClose={() => {
                        const menuEl = document.querySelector(`#${uniqueId} .select__menu`);
                        const containerEl = menuEl?.parentElement;
                        const clonedMenuEl = menuEl?.cloneNode(true);

                        if (!clonedMenuEl) return; // safeguard

                        clonedMenuEl.classList.add("menu--close");
                        clonedMenuEl.addEventListener("animationend", () => {
                            containerEl?.removeChild(clonedMenuEl);
                        });

                        containerEl?.appendChild(clonedMenuEl);
                    }}
                    styles={customSelectMenuStyles}
                />
            </KoerberLanguageSelectorWrapper>
        </>
    )
}

export default LanguageSelector;
